import { render, staticRenderFns } from "./ImageEdit.vue?vue&type=template&id=0671b128&scoped=true&"
import script from "./ImageEdit.vue?vue&type=script&lang=js&"
export * from "./ImageEdit.vue?vue&type=script&lang=js&"
import style0 from "./ImageEdit.vue?vue&type=style&index=0&id=0671b128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671b128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0671b128')) {
      api.createRecord('0671b128', component.options)
    } else {
      api.reload('0671b128', component.options)
    }
    module.hot.accept("./ImageEdit.vue?vue&type=template&id=0671b128&scoped=true&", function () {
      api.rerender('0671b128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/edit/ImageEdit.vue"
export default component.exports